import axios from "axios";


const API_URL = process.env.REACT_APP_API_URL || "";

const globalSettingsApi = {
  getGlobalSettings: async () => {
    const response = await axios.get(`${API_URL}/api/admin/global-settings`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },
  updateGlobalSettings: async (data: { rainNotice?: boolean; instantOrderConfig?: any }) => {
    const response = await axios.put(`${API_URL}/api/admin/global-settings`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },
};

export default globalSettingsApi;